<div class="dozent-picker" [class.is-loading]="loading">
  <!-- Display card: shows the currently linked dozent, independent of
       the nb-select widget. Always visible while a link exists and the
       user is not actively editing. -->
  <div
    class="dozent-picker__current"
    *ngIf="hasLink && !editMode"
  >
    <div class="dozent-picker__current-icon">
      <nb-icon icon="person-outline"></nb-icon>
    </div>
    <div class="dozent-picker__current-info">
      <div class="dozent-picker__current-label">
        {{ 'tutor.dozentLink.currentlyLinked' | translate }}
      </div>
      <div class="dozent-picker__current-name">
        {{ currentDozent?.name || ('tutor.dozentLink.unknownDozent' | translate) }}
      </div>
      <div class="dozent-picker__current-desc" *ngIf="currentDozent?.description">
        {{ currentDozent?.description }}
      </div>
    </div>
    <div class="dozent-picker__current-actions">
      <button
        nbButton
        ghost
        status="basic"
        size="small"
        (click)="enterEditMode()"
        [disabled]="disabled || loading"
      >
        <nb-icon icon="edit-2-outline"></nb-icon>
        {{ 'tutor.dozentLink.change' | translate }}
      </button>
      <button
        nbButton
        ghost
        status="danger"
        size="small"
        (click)="confirmDetach()"
        [disabled]="disabled || loading"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
        {{ 'tutor.dozentLink.removeLink' | translate }}
      </button>
    </div>
  </div>

  <!-- Edit panel: visible when nothing is linked OR the user clicked
       "Ändern". Selection is staged in `pendingDozentId` and only
       applied after the confirm dialog. -->
  <div class="dozent-picker__edit" *ngIf="editMode">
    <div class="dozent-picker__row">
      <nb-select
        class="dozent-picker__select"
        [(selected)]="pendingDozentId"
        (selectedChange)="onPickerChange($event)"
        [disabled]="disabled || loading"
        [placeholder]="'tutor.dozentLink.placeholder' | translate"
      >
        <nb-option value="">{{ 'tutor.dozentLink.none' | translate }}</nb-option>
        <nb-option *ngFor="let d of dozents" [value]="d.id">{{ d.name }}</nb-option>
      </nb-select>

      <button
        *ngIf="canCreateDozent"
        nbButton
        status="basic"
        size="small"
        (click)="toggleCreateDialog()"
        [disabled]="disabled || loading"
      >
        <nb-icon icon="plus-outline"></nb-icon>
        {{ 'tutor.dozentLink.createNew' | translate }}
      </button>
    </div>

    <p class="dozent-picker__hint">
      {{ 'tutor.dozentLink.hint' | translate }}
    </p>

    <!-- Confirm/Cancel only visible after a real change is staged, OR
         when the user is editing an existing link. -->
    <div class="dozent-picker__edit-actions" *ngIf="hasLink || hasPendingChange">
      <button
        *ngIf="hasLink"
        nbButton
        ghost
        status="basic"
        size="small"
        (click)="cancelEdit()"
        [disabled]="loading"
      >
        {{ 'buttons.cancel' | translate }}
      </button>
      <button
        nbButton
        status="primary"
        size="small"
        (click)="confirmApplyChange()"
        [disabled]="loading || !hasPendingChange"
      >
        {{ 'tutor.dozentLink.applyChange' | translate }}
      </button>
    </div>

    <!-- Inline mini form for "Neuen Dozent anlegen" — opens below the
         select so the user keeps context. -->
    <div class="dozent-picker__create" *ngIf="createDialogVisible" [formGroup]="createForm">
      <h6>{{ 'tutor.dozentLink.createTitle' | translate }}</h6>
      <div class="field">
        <label>{{ 'tutor.dozentLink.name' | translate }}</label>
        <input nbInput fullWidth formControlName="name" />
      </div>
      <div class="field">
        <label>{{ 'tutor.dozentLink.description' | translate }}</label>
        <textarea nbInput fullWidth formControlName="description" rows="2"></textarea>
      </div>
      <div class="dozent-picker__create-actions">
        <button nbButton status="basic" size="small" (click)="toggleCreateDialog()">
          {{ 'buttons.cancel' | translate }}
        </button>
        <button
          nbButton
          status="primary"
          size="small"
          (click)="submitCreate()"
          [disabled]="createForm.invalid || loading"
        >
          {{ 'buttons.create' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
